module.exports = __webpack_public_path__ + "img/ringcase@2x.f664395.webp";